import { Layout, Page, ContextualSaveBar } from "@shopify/polaris";
import { useRef, useEffect } from "react";
import { useHistory } from "react-router";
import { useMutation } from "react-query";

import { createOneAccountingCategory } from "api";
import { useSnackbar } from "providers";
import { SharedForm } from "../SharedForm/SharedForm";

export function NewAccountingCategory(props) {
  const skipToContentRef = useRef(null);

  const initialValues = useRef({
    title: "",
    description: "",
    type: "Masraf",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { toggleSnack } = useSnackbar();

  const postMutation = useMutation(createOneAccountingCategory, {
    onSuccess: (response) => {
      toggleSnack({
        key: "accountingCategoryCreateSuccess",
        message: "Muhasebe kategori kaydı başarıyla oluşturulmuştur",
        active: true,
      });
    },
    onError: (error) => {
      toggleSnack({
        key: "accountingCategoryCreateError",
        error: true,
        message: error?.response?.data?.message,
        active: true,
      });
    },
  });

  return (
    <Page
      title="Yeni Kategori"
      narrowWidth={true}
      breadcrumbs={[{ content: "Kategoriler", url: "/accounting/categories" }]}
    >
      <Layout>
        <a id="SkipToContentTarget" ref={skipToContentRef} tabIndex={-1} />
        <SharedForm
          onSubmit={(values) => postMutation.mutate(values)}
          initialValues={initialValues.current}
          savebarRender={(values) => (
            <Savebar {...values} isLoading={postMutation.isLoading} />
          )}
        />
      </Layout>
    </Page>
  );
}

function Savebar({ handleSubmit, isValid, isLoading }) {
  const history = useHistory();
  return (
    <ContextualSaveBar
      saveAction={{
        onAction: handleSubmit,
        loading: isLoading,
        disabled: !isValid,
        content: "Kaydet",
      }}
      message="Yeni kategori"
      discardAction={{
        onAction: () => history.push("/accounting/categories"),
        content: "Geri",
      }}
    />
  );
}
